"use client"

import React, { memo, useCallback } from "react";
import { Checkbox } from "@/components/ui/checkbox";
import { cn } from "@/lib/utils";
import { Paper } from "@/stores/slices/paperSlice";

type HeaderProps = {
  papers: Paper[];
  checked: boolean | "indeterminate";
  onToggle: (checked: boolean) => void;
};

export const SelectionHeader = memo(function SelectionHeader({ papers, checked, onToggle }: HeaderProps) {
  // 稳定化 onCheckedChange 回调，避免每次渲染都创建新函数
  const handleCheckedChange = useCallback((value: boolean | string) => {
    onToggle(!!value);
  }, [onToggle]);

  return (
    <Checkbox
      checked={checked}
      onCheckedChange={handleCheckedChange}
      aria-label="全选"
      className={cn(
        "translate-y-[2px] data-[state=unchecked]:border-foreground",
        !papers.length && "invisible"
      )}
    />
  );
}, (prevProps, nextProps) => {
  // 自定义比较函数，只在关键 props 变化时重新渲染
  return (
    prevProps.checked === nextProps.checked &&
    prevProps.papers.length === nextProps.papers.length &&
    prevProps.onToggle === nextProps.onToggle
  );
});

type CellProps = {
  paperId: string;
  checked: boolean;
  onToggle: (checked: boolean) => void;
};

export const SelectionCell = memo(function SelectionCell({ paperId, checked, onToggle }: CellProps) {
  // 稳定化 onCheckedChange 回调，避免每次渲染都创建新函数
  const handleCheckedChange = useCallback((value: boolean | string) => {
    onToggle(!!value);
  }, [onToggle]);

  return (
    <Checkbox
      checked={checked}
      onCheckedChange={handleCheckedChange}
      aria-label="选中行"
      className="translate-y-[2px] data-[state=unchecked]:border-foreground"
    />
  );
}, (prevProps, nextProps) => {
  // 自定义比较函数，只在关键 props 变化时重新渲染
  return (
    prevProps.paperId === nextProps.paperId &&
    prevProps.checked === nextProps.checked &&
    prevProps.onToggle === nextProps.onToggle
  );
});


